import { render } from "./ActiveOrder.vue?vue&type=template&id=c94768b2&scoped=true"
import script from "./ActiveOrder.vue?vue&type=script&lang=js"
export * from "./ActiveOrder.vue?vue&type=script&lang=js"

import "./ActiveOrder.vue?vue&type=style&index=0&id=c94768b2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94768b2"]])

export default __exports__